<template>
    <div class="notification" :class="type">
        <svg class="voxion"><use xlink:href="#icon-info"></use></svg>
        <span v-text="text"></span>
    </div>
</template>

<script>
    export default {
        name: 'Notification',
        props: ['type', 'text']
    }
</script>